class MCartAddons extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      zipCode: '[name="address[zip]"]',
      province: '[name="address[province]"]',
      country: '[name="address[country]"]',
      addressForm: '[data-address="root"]',
      shippingMessage: ".m-cart-addon__shipping-rate",
      cartDiscountCode: '[name="discount"]',
      cartDiscountCodeNoti: "[data-discount-noti]",
      cartNote: '[name="note"]',
      saveAddonButton: ".m-cart-addon--save",
      closeAddonButton: ".m-cart-addon--close",
      calcShippingButton: ".m-cart-addon--calculate",
      triggerAddonButton: ".m-cart-addon--trigger-button",

      // moet matchen met input: name="attributes[Delivery-Date]"
      devliveryTime: '[name="attributes[Delivery-Date]"]',
    };

    this.cartWrapper = document.querySelector(".m-cart-drawer");
    this.isCartPage = window.MinimogSettings?.templateName === "cart";
    if (this.isCartPage) {
      this.cartWrapper = document.querySelector(".m-cart__footer--wrapper");
    }

    // Geen cart wrapper? stop, anders krijg je errors op andere paginas
    if (!this.cartWrapper) return;

    this.initAddress = false;
    this.cartOverlay = this.cartWrapper.querySelector(".m-cart__overlay");
    this.domNodes = queryDomNodes(this.selectors, this);
    this.rootUrl = window.Shopify?.routes?.root || "/";

    this.discountCodeKey = "minimog-discount-code";
    this.deliveryCodeKey = "minimog-delivery-code";

    this.init();
  }

  init() {
    const { cartDiscountCode, cartDiscountCodeNoti } = this.domNodes;

    addEventDelegate({
      selector: this.selectors.triggerAddonButton,
      context: this,
      handler: (e, addonButton) => {
        e.preventDefault();

        if (this.isCartPage) {
          const addonCurrentActive = document.querySelector(".m-cart-addon__body.open");
          if (addonCurrentActive) addonCurrentActive.classList.remove("open");
        }

        const { open: addonTarget } = addonButton.dataset;
        const addonNode = this.cartWrapper.querySelector(`#m-addons-${addonTarget}`);

        this.removeActiveAllButton();
        addonButton.classList.add("active");
        addonNode && addonNode.classList.add("open");
        this.cartOverlay && this.cartOverlay.classList.add("open");
        this.openAddon = addonNode;

        // Delivery: min-date updaten wanneer je dit panel opent
        if (addonTarget === "delivery") {
          const deliveryDateElm = this.querySelector("#delivery-date") || this.domNodes.devliveryTime;
          if (deliveryDateElm) deliveryDateElm.min = this.getLocalDateMin();
        }

        if (addonTarget === "shipping") {
          fetchSection("country-options", { url: window.MinimogSettings.base_url })
            .then((html) => {
              const select = html.querySelector("#AddressCountry");
              const options = select && select.querySelectorAll("option");
              const defaultSelect = addonNode.querySelector("#MadrressCountry select");

              options &&
                options.forEach((option) => {
                  defaultSelect && defaultSelect.appendChild(option);
                });

              this.setupCountries();
              defaultSelect.value = defaultSelect && defaultSelect.dataset.default;
            })
            .catch(console.error);
        }
      },
    });

    addEventDelegate({
      selector: this.selectors.closeAddonButton,
      context: this.cartWrapper,
      handler: this.close.bind(this),
    });

    addEventDelegate({
      selector: this.selectors.calcShippingButton,
      context: this.cartWrapper,
      handler: this.calcShipping.bind(this),
    });

    // discount: localStorage restore
    if (cartDiscountCode) {
      const code = localStorage.getItem(this.discountCodeKey);
      if (code) {
        cartDiscountCode.value = code;
        if (cartDiscountCodeNoti) cartDiscountCodeNoti.style.display = "inline";
      }
    }

    // Als drawer-script al de gate beheert, doen wij dat niet.
    // Anders (bijv. cart page) mogen we wel als fallback.
    if (this.shouldSelfGate()) {
      this.syncGateUI(false);
    }

    // delivery: sync met Shopify cart (leidend), localStorage alleen fallback
    this.syncDeliveryFromCart();

    this.saveAddonValue();

    // min = obv cutoff 12:00 + business days (geen weekend)
    const deliveryDateElm = this.querySelector("#delivery-date") || this.domNodes.devliveryTime;
    if (deliveryDateElm) deliveryDateElm.min = this.getLocalDateMin();

    // live validatie + auto-correct
    this.bindDeliveryDateInput();
  }

  // ----------------
  // Helpers: delivery
  // ----------------
  pad(n) {
    return String(n).padStart(2, "0");
  }

  formatISODate(d) {
    return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}`;
  }

  // NL display: dd-mm-yyyy
  formatDateNL(isoDate) {
    if (!isoDate) return "";
    const parts = String(isoDate).split("-");
    if (parts.length !== 3) return isoDate;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  updateDeliveryDisplay(isoDate) {
    const wrap = this.querySelector("[data-delivery-selected]");
    const val = this.querySelector("[data-delivery-selected-value]");
    if (!wrap || !val) return;

    if (isoDate) {
      val.textContent = this.formatDateNL(isoDate);
      wrap.style.display = "";
    } else {
      val.textContent = "";
      wrap.style.display = "none";
    }
  }

  notify(message, type = "error") {
    const target = this.querySelector(".m-cart-addon-message-error");
    if (window.MinimogTheme?.Notification?.show && target) {
      window.MinimogTheme.Notification.show({
        target,
        method: "appendChild",
        type,
        message,
        last: 3500,
        sticky: false,
      });
    } else {
      alert(message);
    }
  }

  normalizeISO(value) {
    if (!value) return "";
    return String(value).split("T")[0].trim();
  }

  isWeekend(isoDate) {
    if (!isoDate) return false;
    const d = new Date(`${isoDate}T00:00:00`);
    const day = d.getDay();
    return day === 0 || day === 6; // zondag of zaterdag
  }

  addBusinessDays(dateObj, count) {
    const d = new Date(dateObj);
    let added = 0;

    while (added < count) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day === 0 || day === 6) continue; // skip weekend
      added++;
    }
    return d;
  }

  // Cutoff 12:00:
  // - vóór 12:00 -> +1 werkdag
  // - vanaf 12:00 -> +2 werkdagen
  getLocalDateMin() {
    const now = new Date();
    const base = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 00:00
    const cutoffHour = 12;
    const businessDaysToAdd = now.getHours() < cutoffHour ? 1 : 2;

    const d = this.addBusinessDays(base, businessDaysToAdd);
    return this.formatISODate(d);
  }

  isValidDeliveryDate(isoDate) {
    if (!isoDate) return false;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return false;
    if (this.isWeekend(isoDate)) return false;
    return isoDate >= this.getLocalDateMin();
  }

  // Corrigeer naar eerstvolgende geldige datum (>= min, geen weekend)
  getNextValidDate(isoDate) {
    const v = this.normalizeISO(isoDate);
    if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return "";

    let d = new Date(`${v}T00:00:00`);
    if (Number.isNaN(d.getTime())) return "";

    const min = this.getLocalDateMin();
    let cur = this.formatISODate(d);

    while (this.isWeekend(cur) || cur < min) {
      d.setDate(d.getDate() + 1);
      cur = this.formatISODate(d);
    }
    return cur;
  }

  // ----------------
  // Gate fallback (alleen als drawer-script dit niet al doet)
  // ----------------
  shouldSelfGate() {
    const drawer = document.getElementById("MinimogCartDrawer");
    // jouw drawer script zet: drawer.dataset.deliveryGateInit = '1'
    if (drawer && drawer.dataset.deliveryGateInit === "1") return false;
    return true;
  }

  getWarningNode() {
    return (
      this.cartWrapper.querySelector("[data-delivery-date-warning]") ||
      document.querySelector("[data-delivery-date-warning]")
    );
  }

  syncGateUI(hasDate) {
    if (!this.shouldSelfGate()) return;

    const warn = this.getWarningNode();
    const btn =
      this.cartWrapper.querySelector('button[name="checkout"]') ||
      this.cartWrapper.querySelector('input[name="checkout"]');

    const accel = this.cartWrapper.querySelector(".additional-checkout-buttons");

    if (warn) warn.style.display = hasDate ? "none" : "";
    if (!btn) return;

    // Terms (als aanwezig) moeten leidend blijven
    const terms = this.cartWrapper.querySelector('input[name="agree_terms"]');
    const termsOk = !terms || terms.checked;

    if (!hasDate) {
      btn.disabled = true;
      btn.setAttribute("data-disabled-by-delivery-date", "1");
      if (accel) accel.style.display = "none";
      return;
    }

    if (accel) accel.style.display = "";

    // Alleen re-enablen als wij 'm disabled hebben
    if (btn.getAttribute("data-disabled-by-delivery-date") === "1") {
      btn.removeAttribute("data-disabled-by-delivery-date");
      btn.disabled = !termsOk;
    }
  }

  dispatchDeliveryEvent(value) {
    document.dispatchEvent(
      new CustomEvent("minimog:delivery-date-updated", { detail: { value: value || "" } })
    );
  }

  // Centrale “apply” (ook gebruikt door sync + save + input change)
  applyDeliveryDate(rawValue, { silent = false } = {}) {
    const input = this.domNodes.devliveryTime || this.querySelector("#delivery-date");
    const normalized = this.normalizeISO(rawValue);

    // leegmaken
    if (!normalized) {
      if (input) input.value = "";
      localStorage.setItem(this.deliveryCodeKey, "");
      this.updateCartAttributes({ "Delivery-Date": "" });
      this.updateDeliveryDisplay("");
      this.syncGateUI(false);
      this.dispatchDeliveryEvent("");
      return;
    }

    const suggested = this.getNextValidDate(normalized);

    if (!suggested) {
      if (input) input.value = "";
      localStorage.setItem(this.deliveryCodeKey, "");
      this.updateCartAttributes({ "Delivery-Date": "" });
      this.updateDeliveryDisplay("");
      this.syncGateUI(false);
      this.dispatchDeliveryEvent("");

      if (!silent) {
        const msg =
          window.MinimogStrings?.valideDateTimeDelivery ||
          "Selecteer een geldige afleverdatum (geen weekend, en vanaf de eerst mogelijke werkdag).";
        this.notify(msg, "error");
      }
      return;
    }

    // Als gekozen datum afwijkt -> autocorrect (weekend / te vroeg)
    if (suggested !== normalized) {
      if (input) input.value = suggested;

      if (!silent) {
        const min = this.getLocalDateMin();
        const msg =
          suggested === min
            ? `Voor 12:00 besteld? Na 12:00 schuift de eerstvolgende leverdag op. Datum aangepast naar ${this.formatDateNL(
                suggested
              )}.`
            : `Geen levering in het weekend. Datum aangepast naar ${this.formatDateNL(suggested)}.`;
        this.notify(msg, "warning");
      }
    }

    localStorage.setItem(this.deliveryCodeKey, suggested);
    this.updateCartAttributes({ "Delivery-Date": suggested });
    this.updateDeliveryDisplay(suggested);
    this.syncGateUI(true);
    this.dispatchDeliveryEvent(suggested);
  }

  bindDeliveryDateInput() {
    const el = this.querySelector("#delivery-date") || this.domNodes.devliveryTime;
    if (!el) return;

    el.addEventListener("change", () => {
      this.applyDeliveryDate(el.value, { silent: false });
    });
  }

  syncDeliveryFromCart() {
    const input = this.domNodes.devliveryTime || this.querySelector("#delivery-date");
    if (!input) return;

    fetch(`${this.rootUrl}cart.js`)
      .then((res) => res.json())
      .then((cart) => {
        const serverVal = cart?.attributes?.["Delivery-Date"] || "";
        const normalizedServerVal = this.normalizeISO(serverVal);

        // 1) Shopify cart is leidend
        if (normalizedServerVal) {
          const suggested = this.getNextValidDate(normalizedServerVal);

          if (suggested) {
            input.value = suggested;
            localStorage.setItem(this.deliveryCodeKey, suggested);

            // als serverVal afwijkt van regels -> corrigeer cart attribute stilletjes
            if (suggested !== normalizedServerVal) {
              this.updateCartAttributes({ "Delivery-Date": suggested });
            }

            this.updateDeliveryDisplay(suggested);
            this.syncGateUI(true);
            this.dispatchDeliveryEvent(suggested);
            return;
          }

          // ongeldige serverVal -> leegmaken
          input.value = "";
          localStorage.setItem(this.deliveryCodeKey, "");
          this.updateCartAttributes({ "Delivery-Date": "" });
          this.updateDeliveryDisplay("");
          this.syncGateUI(false);
          this.dispatchDeliveryEvent("");
          return;
        }

        // 2) fallback: localStorage -> push naar cart
        const stored = localStorage.getItem(this.deliveryCodeKey);
        const normalizedStored = this.normalizeISO(stored);

        if (normalizedStored) {
          const suggested = this.getNextValidDate(normalizedStored);
          if (suggested) {
            input.value = suggested;
            this.updateCartAttributes({ "Delivery-Date": suggested });
            this.updateDeliveryDisplay(suggested);
            this.syncGateUI(true);
            this.dispatchDeliveryEvent(suggested);
            return;
          }
        }

        // 3) geen datum
        input.value = "";
        this.updateDeliveryDisplay("");
        this.syncGateUI(false);
        this.dispatchDeliveryEvent("");
      })
      .catch(console.error);
  }

  // ----------------
  // Minimog standaard helpers
  // ----------------
  removeActiveAllButton() {
    const triggerButtons = this.querySelectorAll(this.selectors.triggerAddonButton);
    triggerButtons && triggerButtons.forEach((button) => button.classList.remove("active"));
  }

  setupCountries() {
    if (this.initAddress) return;
    if (window.Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
        hideElement: "AddressProvinceContainer",
      });
      this.initAddress = true;
    }
  }

  close(event) {
    event.preventDefault();
    this.openAddon?.classList.remove("open");
    this.cartOverlay && this.cartOverlay.classList.remove("open");
    this.removeActiveAllButton();
    this.openAddon = null;
  }

  calcShipping(event) {
    event.preventDefault();

    const actionsWrapper = event.target.closest(".m-cart-addon__action");
    if (!actionsWrapper) return;

    actionsWrapper.classList.add("m-spinner-loading");

    if (!this.domNodes.country || !this.domNodes.province || !this.domNodes.shippingMessage) {
      actionsWrapper.classList.remove("m-spinner-loading");
      return;
    }

    const zipCode = (this.domNodes.zipCode?.value || "").trim();
    const country = this.domNodes.country.value;
    const province = this.domNodes.province.value;

    this.domNodes.shippingMessage.classList.remove("error");
    this.domNodes.shippingMessage.innerHTML = "";

    const showDeliveryDays = actionsWrapper.dataset.showDeliveryDays === "true";

    fetch(
      `${this.rootUrl}cart/shipping_rates.json?shipping_address%5Bzip%5D=${encodeURIComponent(
        zipCode
      )}&shipping_address%5Bcountry%5D=${encodeURIComponent(
        country
      )}&shipping_address%5Bprovince%5D=${encodeURIComponent(province)}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res && res.shipping_rates) {
          const { shipping_rates } = res;
          const { shippingRatesResult, noShippingRate } = window.MinimogStrings || {};

          if (shipping_rates.length > 0) {
            actionsWrapper.classList.remove("m-spinner-loading");

            const shippingLabel = document.createElement("P");
            shippingLabel.classList.add("m-cart-addon__shipping-rate--label");
            shippingLabel.innerHTML = `${(shippingRatesResult || "{{count}} shipping rates").replace(
              "{{count}}",
              shipping_rates.length
            )}:`;
            this.domNodes.shippingMessage.appendChild(shippingLabel);

            shipping_rates.map((rate) => {
              const { deliveryOne = "Day", deliveryOther = "Days" } = actionsWrapper.dataset;
              let deliveryDays = "";

              if (rate.delivery_days?.length > 0 && showDeliveryDays) {
                let textDay = deliveryOne;
                const firstDeliveryDay = rate.delivery_days[0];
                const lastDeliveryDay = rate.delivery_days.at(-1);

                if (firstDeliveryDay > 1) textDay = deliveryOther;

                deliveryDays =
                  firstDeliveryDay === lastDeliveryDay
                    ? `(${firstDeliveryDay} ${textDay})`
                    : `(${firstDeliveryDay} - ${lastDeliveryDay} ${textDay})`;
              }

              const shippingRateItem = document.createElement("P");
              shippingRateItem.classList.add("m-cart-addon__shipping-rate--item");
              shippingRateItem.innerHTML = `${rate.name}: <span>${rate.price} ${Shopify.currency.active}</span> ${deliveryDays}`;
              this.domNodes.shippingMessage.appendChild(shippingRateItem);
            });
          } else {
            actionsWrapper.classList.remove("m-spinner-loading");
            this.domNodes.shippingMessage.innerHTML = `<p>${noShippingRate || "No shipping rates available."}</p>`;
          }
        } else {
          actionsWrapper.classList.remove("m-spinner-loading");
          Object.entries(res).map((error) => {
            this.domNodes.shippingMessage.classList.add(error[0] && error[0].toLowerCase());
            const message = `${error[1][0]}`;
            const shippingRateError = document.createElement("P");
            shippingRateError.classList.add("m-cart-addon__shipping-rate--error");
            shippingRateError.innerHTML = `${message}<sup>*</sup>`;
            this.domNodes.shippingMessage.appendChild(shippingRateError);
          });
        }
      })
      .catch(console.error);
  }

  updateCartAttributes(attributes) {
    const body = JSON.stringify({ attributes });
    return fetch(`${window.MinimogSettings.routes.cart_update_url}`, {
      ...fetchConfig(),
      body,
    });
  }

  saveAddonValue() {
    addEventDelegate({
      event: "click",
      context: this.cartWrapper,
      selector: this.selectors.saveAddonButton,
      handler: (event, target) => {
        event.preventDefault();

        const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;

        if (target.dataset.action === "coupon" && cartDiscountCode) {
          const code = cartDiscountCode.value;
          localStorage.setItem(this.discountCodeKey, code);

          if (cartDiscountCodeNoti) {
            cartDiscountCodeNoti.style.display = code ? "inline" : "none";
          }

          this.close(event);
        }

        if (target.dataset.action === "note") {
          this.updateCartNote();
          this.close(event);
        }

        if (target.dataset.action === "delivery") {
          const raw = devliveryTime ? devliveryTime.value : (this.querySelector("#delivery-date")?.value || "");
          this.applyDeliveryDate(raw, { silent: false });
          this.close(event);
        }
      },
    });
  }

  updateCartNote() {
    if (!this.domNodes.cartNote) return;
    const cartNoteValue = this.domNodes.cartNote.value;
    const body = JSON.stringify({ note: cartNoteValue });
    fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  }
}

customElements.define("m-cart-addons", MCartAddons);
